import React from "react";
import { RichText } from "prismic-reactjs";

export default class ImageWithText extends React.Component {
  render() {
    const { data, prismicCtx } = this.props;
    return (
      <div className="container pt-5 pb-5">
        <div className="row">
          <div className="col-12">
            <div className="text">
              {RichText.render(data.primary.text, prismicCtx.linkResolver)}
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/slices/Text.js